import {isMobile} from './commonMethods';
import {globalImport} from '../common/globalImports';
import {Color} from '../assets';
import {
  backArrow_p4,
  cancel_black_p4,
  close_p4,
  coin,
  coin_p4,
  cross_new_p4,
  down_arrow_p4,
  event_about_p4,
  gift_p4,
  home_sort_p4,
  ic_minus_p4,
  ic_plus_p4,
  info_p4,
  left_arrow_black_p4,
  logoName_p4,
  markets_empty_p4,
  marketTab4,
  marketTab_selected4,
  nothing_card_closed_p4,
  nothing_card_live_p4,
  portfolio_empty_p4,
  portfolioTab4,
  portfolioTab_selected4,
  right_arrow_black_p4,
  right_arrow_p4,
  tick_new_p4,
  tooltip_p4,
  transactions_add_p4,
  transactions_invest_p4,
  transactions_withdraw_p4,
  up_arrow_p4,
  walletTab4,
  walletTab_selected4,
  WhatsApp_p4,
} from './images';
import Colors from '../assets/Color/Colors';
import {globalConfigurableData} from "./globalConstant";

export const BottomTabTheme1 = {
  tabSelectedColor: Color.bgWhite,
  tabUnselectedColor: '#ACACAC',
  tabBottomBarColor: '#1D1D1D',
  tabTextData: [
    {
      iconSelected: '',
      tabLabel: 'Markets',
      isVisible: '',
    },
    {
      iconSelected: '',
      tabLabel: 'Portfolio',
      isVisible: '',
    },
    {
      iconSelected: '',
      tabLabel: 'Fantasy',
      isVisible: false,
    },
    {
      iconSelected: '',
      tabLabel: 'Wallet',
      isVisible: true,
    },
    {
      iconSelected: '',
      tabLabel: 'Account',
      isVisible: false,
    },
  ],
};

export const bottomIconTheme1 = {
  iconConfig: {
    market: marketTab4(),
    wallet: walletTab4(),
    portfolio: portfolioTab4(),
  },
  iconSelectedConfig: {
    market: marketTab_selected4(),
    wallet: walletTab_selected4(),
    portfolio: portfolioTab_selected4(),
  },
};

export const globalConfigurableDataTheme1 = {
  appName: 'TMR Stakes',
  isMobileViewInDesktop: false,
  switchTabSelectedColor: Colors.bgWhite,
  switchTabUnselectedColor: '#ACACAC',
  switchTabUnselectedBorderColor: '#353535',
  newSwitchTabBgColor: '#1D1D1D',
  newSwitchTabSelectedBgColor: '#373738',
  cardBgColor: '#1D1D1D',
  logoUrl: logoName_p4,
  globalThemeColor: '',
  fontColor: '',
  primaryTextColor: Color.bgWhite,
  secondaryTextColor: '#ACACAC',
  tertiaryTextColor: '',
  headerColor: Color.black,
  primaryTextColor1: Color.bgWhite,
  secondaryTextColor1: '#ACACAC',
  tertiaryTextColor1: '#ACACAC',
  quaternaryTextColor1: '#ACACAC',
  contrastTextColor1: Color.bgWhite,
  errorTextColor1: '#FF4F01',
  profitColor: '#38C037',
  lossColor: '#FF4F01',
  borderColor: '#353535',
  yesBtnBlock: '#5ddcff',
  noBtnBlock: '#CA2C92',
  noBtnTxt: Colors.bgWhite,
  yesBtnTxt: Colors.black,
  loaderColor: Colors.bgWhite,
  yesBtnBlockInactive: '#202D20',
  noBtnBlockInactive: '#2E1F29',
  yesBtnBlockInactiveTxt: Colors.bgWhite,
  noBtnBlockInactiveTxt: Colors.bgWhite,
  primaryBtnColor: Color.blueP4,
  secondaryBtnColor: Color.blueP4,
  primaryBtnTxt: Colors.bgWhite,
  greyBtnColor: '#373738',
  greyBtnTxt: Colors.bgWhite,
  disableBtnColor: Colors.disableBtnGrey,
  disableBtnTextColor: Colors.disableBtnTextColor,
  btnBorderRadius: 100,
  imageBgColor: '#373738',
  sortIcon: home_sort_p4,
  back_arrow: backArrow_p4,
  cancel_black: cancel_black_p4,
  close: close_p4,
  cross_new: cross_new_p4,
  down_arrow: down_arrow_p4,
  event_about: event_about_p4,
  gift: gift_p4,
  info: info_p4,
  right_arrow: right_arrow_p4,
  tick_new: tick_new_p4,
  transactions_add: transactions_add_p4,
  transactions_invest: transactions_invest_p4,
  transactions_withdraw: transactions_withdraw_p4,
  up_arrow: up_arrow_p4,
  warning: info_p4,
  WhatsApp: WhatsApp_p4,
  tooltip: tooltip_p4,
  right_arrow_black: right_arrow_black_p4,
  left_arrow_black: left_arrow_black_p4,
  ic_plus: ic_plus_p4,
  ic_minus: ic_minus_p4,
  nothing_card_live: nothing_card_live_p4,
  nothing_card_closed: nothing_card_closed_p4,
  coin: coin_p4,
  markets_empty: markets_empty_p4,
  portfolio_empty: portfolio_empty_p4,
  initFunction: () => {
    document.body.style.backgroundColor = '#000000';
    document.body.style.minHeight = ' 100%';
    document.body.style.backgroundImage =
      'linear-gradient(180deg, #000000 25%, #2d5853 100%)';
    document.body.style.backgroundAttachment = 'fixed';
  },
};

export const GlobalScreensTheme1 = {
  Home: {
    isShowBanner: true,
    isShowDefaultBanner: false,
    categorySelectedBgColor: Color.blueP4,
    categoryUnselectedBgColor: '#1D1D1D',
    categoryUnselectedColor: '#ACACAC',
    categorySelectedBorderColor: Color.blueP4,
    categorySelectedColor: Color.bgWhite,
    dropdownBgColor: '#1D1D1D',
    dropdownRadioBtnColor: Colors.bgWhite,
    tradeCardBgColor: '#1D1D1D',
    hashTagTitleColor: Colors.bgWhite,
    hashTagBgColor: '#1D1D1D',
    yesBtnBlock: '#38C037',
    noBtnBlock: '#CA2C92',
    noBtnTxt: Colors.bgWhite,
    yesBtnTxt: Colors.bgWhite,
    subCategorySelectedBgColor: Color.blueP4,
    categoryBorder: 0.5,
  },
  Portfolio: {
    cardBgColor: '#1D1D1D',
    borderColor: '#353535',
    yesBtnBlock: '#202D20',
    noBtnBlock: '#2E1F29',
    noBtnTxt: '#CA2C92',
    yesBtnTxt: '#3c67e3',
    yesBtnBorder: '#38C037',
    noBtnBorder: '#CA2C92',
    btnBorderRadius: 100,
  },
  Event: {
    cardBgColor: '#1D1D1D',
    borderColor: '#353535',
    isShowEventShare: '',
    yesBtnBlock: '#5ddcff4d',
    noBtnBlock: '#2E1F29',
    noBtnTxt: '#CA2C92',
    yesBtnTxt: '#5ddcff',
    tipColor: '#38C037',
    InvestedBox: '#1D1D1D',
    InvestedTxt: Colors.bgWhite,
    StatsBlock: '#1D1D1D'
  },
  SingleOrder: {
    switchTabSelectedColor: Colors.bgWhite,
    switchTabUnselectedColor: '#ACACAC',
    switchTabUnselectedBorderColor: '#353535',
    highlightColor: '#38C037',
    switchSliderSelectedColor: Colors.bgWhite,
    switchSliderUnselectedColor: '#ACACAC',
    radioBorder: Colors.bgWhite,
    inputColor: '#373738',
  },
  Wallet: {
    cardBgColor: '#1D1D1D',
    highlightColor: Colors.bgWhite,
    transactionBox: '#1D1D1D',
    isShowAddWallet: '',
    isShowWithdrawWallet: '',
    isShowFAQ: '',
    isShowKYCStatus: '',
    isShowCouponCodeAddMoney: '',
    borderColorWallet: '',
    walletSummaryBtnColor: '#373738',
    partnerPopUp: true,
    partnerPopUpMessage: "Please visit your TMR wallet to Add/Withdraw funds."
  },
  Account: {
    showAccount: false,
    listOptions: [
      {
        name: '',
        redirectLinks: '',
        icon: '',
      },
    ],
  },
  TxnPage: {
    creditAmtColor: '',
    debitAmtColor: '',
  },
};
